import { Style, Icon, Text, Fill, Stroke } from 'ol/style';

let zone_style_urban = new Style({
    stroke: new Stroke({
        color: "#ff555555",
        width: 6,
    }),
    fill: new Fill({
        color: "#ff55554d",
    })
});

let zone_style_not_urban = new Style({
    stroke: new Stroke({
        color: "#55ff5555",
        width: 6,
    }),
    fill: new Fill({
        color: "#55ff554d",
    })
});
let zone_style_text = new Style({
    text: new Text({
        font: 'bold 20px sans-serif',
        //fill: new Fill({ color: 'rgb(0,0,0)' }),
        //stroke: new Stroke({ color: 'rgb(255,255,255)', width: 1 }),
        padding: [2, 0, 0, 2],
        textAlign: "center",
        justify: "center",
    }),
});

function zone_style_fun(feature)
{
    let zonedo = feature.get("zonedo");
    let name = zonedo.name;
    let text_style = zone_style_text.clone();

    text_style.getText().setText(name);

    let zone_style;
    if(zonedo.not_urban)
    {
        zone_style = zone_style_not_urban;
    }
    else
    {
        zone_style = zone_style_urban;
    }
    return [zone_style, text_style];
}

export { zone_style_fun };